// Configuration des étapes d'onboarding pour chaque type d'utilisateur

export const eleveOnboardingSteps = [
  {
    target: '[data-tour="credits"]',
    title: 'Vos crédits',
    content: 'Ici vous voyez vos crédits disponibles. Chaque crédit vous permet de réserver un cours avec un professeur.',
    icon: '💳',
    position: 'bottom'
  },
  {
    target: '[data-tour="action-reserver"]',
    title: 'Réserver un cours',
    content: 'Cliquez ici pour trouver un professeur et réserver votre premier cours d\'arabe !',
    icon: '📌',
    position: 'bottom'
  },
  {
    target: '[data-tour="tabs"]',
    title: 'Navigation',
    content: 'Utilisez ces onglets pour voir vos cours programmés, votre historique et vos évaluations.',
    icon: '📊',
    position: 'bottom'
  },
  {
    target: '[data-tour="alphabet"]',
    title: 'Apprendre l\'alphabet',
    content: 'Commencez par découvrir l\'alphabet arabe ! Un outil interactif pour apprendre les lettres.',
    icon: '🔤',
    position: 'top'
  },
  {
    target: '[data-tour="islamic"]',
    title: 'Contenu islamique',
    content: 'Explorez les 5 piliers de l\'Islam, apprenez des sourates du Coran et les prières.',
    icon: '🕌',
    position: 'top'
  }
];

export const profOnboardingSteps = [
  {
    target: '[data-tour="prof-tabs"]',
    title: 'Navigation',
    content: 'Utilisez ces onglets pour accéder aux demandes de cours, vos disponibilités et votre profil.',
    icon: '📋',
    position: 'bottom'
  },
  {
    target: '[data-tour="prof-revenus"]',
    title: 'Vos revenus',
    content: 'Suivez vos gains en temps réel. Vous verrez ici le total de vos revenus et les paiements en attente.',
    icon: '💰',
    position: 'bottom'
  },
  {
    target: '[data-tour="prof-stats"]',
    title: 'Vos statistiques',
    content: 'Consultez le nombre de cours donnés, les cours à venir et les avis reçus de vos élèves.',
    icon: '📈',
    position: 'bottom'
  },
  {
    target: '[data-tour="prof-prochains"]',
    title: 'Prochains cours',
    content: 'Vos cours à venir apparaissent ici. Cliquez sur "Rejoindre" pour démarrer une session vidéo.',
    icon: '🕐',
    position: 'top'
  }
];
